import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ContextPopover from "./ContextPopover";

interface ContextPillProps {
  layerCount?: number;
  contentId?: number;
  excludedCount?: number;
  onExclusionsChange?: (count: number) => void;
}

export const ContextPill = ({
  layerCount = 0,
  contentId,
  excludedCount = 0,
  onExclusionsChange,
}: ContextPillProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      if (isOpen && containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [isOpen]);

  return (
    <div ref={containerRef} className="relative mb-2">
      <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-100 text-[11px] text-gray-600">
        <span>{t("general.assistantScenarIa.contextLabel", { count: layerCount })}</span>
        {excludedCount > 0 && (
          <span className="text-amber-600">
            {t("general.assistantScenarIa.contextExcludedBadge", {
              count: excludedCount,
            })}
          </span>
        )}
        <span className="text-gray-300">·</span>
        <button
          type="button"
          className="text-green-500 hover:text-green-600"
          onClick={() => setIsOpen((v) => !v)}
          aria-expanded={isOpen}
        >
          {t("general.assistantScenarIa.contextEdit")}
        </button>
      </div>
      {isOpen && (
        <div className="absolute z-10 mt-1 left-0 w-64 rounded-md border border-gray-200 bg-white shadow-sm p-2">
          <ContextPopover
            contentId={contentId}
            onChange={(excluded) => onExclusionsChange?.(excluded.length)}
          />
        </div>
      )}
    </div>
  );
};

export default ContextPill;
